import { switcher } from './bot/flow-frameworks/switcher';
import { ExternalTransactionKind, ExternalTransactionType } from './bot/enum/ExternalTransactionType';
import { TransactionType, TransactionStatus } from './config';
import { logger } from '@/common/api/logger';

export const transactionParamsSwitch = switcher<ExternalTransactionKind, { type: number; status: number }>()
  .when(ExternalTransactionType.DEPOSITS_SUCCESSFUL, () => ({
    type: TransactionType.Deposit,
    status: TransactionStatus.Successful,
  }))
  .when(ExternalTransactionType.DEPOSITS_FAILED, () => ({
    type: TransactionType.Deposit,
    status: TransactionStatus.Failed,
  }))
  .when(ExternalTransactionType.DEPOSITS_PENDING, () => ({
    type: TransactionType.Deposit,
    status: TransactionStatus.Pending,
  }))
  .when(ExternalTransactionType.WITHDRAWALS_SUCCESSFUL, () => ({
    type: TransactionType.Withdrawal,
    status: TransactionStatus.Successful,
  }))
  .when(ExternalTransactionType.WITHDRAWALS_FAILED, () => ({
    type: TransactionType.Withdrawal,
    status: TransactionStatus.Failed,
  }))
  .when(ExternalTransactionType.WITHDRAWALS_PENDING, () => ({
    type: TransactionType.Withdrawal,
    status: TransactionStatus.Pending,
  }))
  .none((type) => logger.error('[TRANSACTION_TYPE] Not identified', { type }));

export const betsTypeSwitch = switcher<ExternalTransactionKind, string>()
  .when(ExternalTransactionType.BETS_LOST, () => '30')
  .when(ExternalTransactionType.BETS_UNSETTLED, () => '0,90')
  .when(ExternalTransactionType.BETS_VOIDED, () => '40')
  .when(ExternalTransactionType.BETS_WON, () => '10,20')
  .none((type) => logger.error('[BET_TYPE] Not identified', { type }));
